import { ConversationDto } from './conversation.dto';

export class ConversationListResponseDto {
    items: ConversationDto[];
    totalCount: number;
}
